"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useSearch = require("../../hooks/questionnaire/useSearch");
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const QuestionWithSearch = _ref => {
  let {
    question,
    selections
  } = _ref;
  const {
    handsetSearchList,
    searchText,
    minCharacters,
    onChange,
    onSelect,
    onFilter
  } = (0, _useSearch.useSearch)(question, selections);
  if (handsetSearchList.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SearchSuggestionWithLabel, {
    dataAttributes: {
      'data-testid': 'question-with-search'
    },
    fieldWrapper: {
      label: _services.Services.locale.localeString('Questionnaire.SearchComponentLabel'),
      width: 'full'
    },
    searchSuggestion: {
      suggestions: handsetSearchList,
      value: searchText,
      id: 'handset-search',
      onChange,
      handleFiltering: value => onFilter(value, handsetSearchList),
      onSelect,
      minCharacters
    }
  });
};
var _default = QuestionWithSearch;
exports.default = _default;